<template>
  <div class="page-container">
    <Filter :params="params" @search="searchData"></Filter>
    <Table :tableData="tableDataList" :total="total" @update="updatePage">
      <el-table-column type="index" align="center" :label="$t('pages.indexNo')" width="60px" />
      <el-table-column prop="createTime" :label="$t('activity.list.createTime')" />
      <el-table-column prop="userName" :label="$t('activity.packetjoin.name')" />
      <el-table-column prop="phoneNumber" :label="$t('activity.packetjoin.phone')">
        <template #default="{row}">
          {{ row.phoneNumber &&  (String(row.phoneNumber).slice(0,3)+'****'+String(row.phoneNumber).slice(7))}}
        </template>
      </el-table-column>
      <el-table-column prop="scoreType" :label="$t('activity.points.rewardSource')" />
      <el-table-column prop="score" :label="$t('activity.points.points')" />
    </Table>
  </div>
</template>

<script>
import { request } from "@/utils/request";
import { common } from "@/common/mixin";
import { reactive, toRefs } from "@vue/reactivity";
// import { ElMessage } from "element-plus";
import Table from "@/components/table/index";
import Filter from "@/components/table/filter";
import { useI18n } from 'vue-i18n'
export default {
  components: {
    Table,
    Filter,
  },
  mixins: [common],
  setup() {
    const { t } = useI18n()
    const state = reactive({
      query: {},
      page: 1,
      size: 10,
      total: 0,
      dialogFormVisible: false,
      tableDataList: [],
      detailform: {
        robotModel: '',
        userName: '',
        email: '',
        phoneNumber: '',
        company: '',
        industry: ''
      },
      params: [
        {
          type: "Input",
          key: "userName",
          value: "",
          label: t('activity.points.name'),
        },
        {
          type: "Input",
          key: "phoneNumber",
          value: "",
          label: t('activity.packetjoin.phone'),
        }
      ]
    })
    const getData = async () => {
      try {
        const res = await request("getScoreList", {
          ...state.query,
          page: state.page,
          size: state.size,
        });
        console.log("getScoreList", res);
        state.tableDataList = res.records;
        state.total = res.total;
      } catch (error) {
        console.error(error);
      }
    };
    const searchData = async (data) => {
      state.query = data
      getData()
    }
    const updatePage = (page, size) => {
      state.page = page || 1
      state.size = size || 10
      getData()
    }
    getData();
    return {
      ...toRefs(state),
      getData,
      searchData,
      updatePage
    };
  },
};
</script>

<style lang="scss" scoped>
.page-container {
  height: 100%;
  padding: 50px 10px 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}
</style>
